export default __webpack_public_path__ + "assets/14fcf7fee15b32c4aad1ea0a10bba0d9.jpeg";